import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {InvitationsComponent} from './invitations.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.invitations.pageInRouting,
    data: {data: PAGES_AND_PATHS.invitations},
    component: InvitationsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./invitations.module').then(m => m.InvitationsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvitationsRoutingModule { }
